module.exports = __webpack_public_path__ + "img/23.5f580742.jpg";